<!-- 中期考核表 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 38.14">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="29.54" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="29.54" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="26.13" y1="18.78" x2="26.13" y2="28.38" />
        <rect
          class="cls-3"
          x="21.69"
          y="21.34"
          width="8.88"
          height="3.43"
          rx="1.05"
        />
        <path
          class="cls-4"
          d="M24,0a1,1,0,0,1,.67.28l0,0,7,7.79a1,1,0,0,1,.24.53v.07l0,6.19A1,1,0,0,1,30,15V9.62H24.31a1,1,0,0,1-.95-.89V1.9H7.46A1.13,1.13,0,0,0,6.35,3V26.59A1.12,1.12,0,0,0,7.4,27.71H18a1,1,0,0,1,1,.95,1,1,0,0,1-.9.95H7.46a3,3,0,0,1-3-2.95V3A3,3,0,0,1,7.38,0H24Zm1.3,3.84V7.72h3.47L25.26,3.84Z"
        />
        <path
          class="cls-4"
          d="M9.74,19.29h7.07a.95.95,0,0,1,0,1.9H9.74a.95.95,0,0,1,0-1.9Zm0,3.8h7.07a1,1,0,0,1,0,1.91H9.74a1,1,0,0,1,0-1.91ZM15,3.94h.08a1.64,1.64,0,0,1,.54.13l.07,0,6.15,3.28a1.46,1.46,0,0,1,.28,2.38v4.07a.74.74,0,0,1-1.47,0V10.59l-1,.52v3.26a.73.73,0,0,1-.35.63l0,0L15.39,17.1a.72.72,0,0,1-.64,0l-.05,0L10.76,15a.72.72,0,0,1-.39-.6v-3.3L8.2,10a1.46,1.46,0,0,1-.06-2.54l.06,0,6.15-3.28A1.43,1.43,0,0,1,15,3.94ZM21.42,15a.74.74,0,0,1,.75.72.75.75,0,0,1-.73.75h0a.74.74,0,0,1,0-1.48Zm-3.17-3.12-2.53,1.35a1.45,1.45,0,0,1-1.3,0l-.07,0L11.84,11.9v2L15,15.62l3.21-1.69ZM15,5.41,8.92,8.68,15,11.94l6.12-3.26L15,5.41Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 38.14">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="29.54" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="29.54" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="26.13" y1="18.78" x2="26.13" y2="28.38" />
        <rect
          class="cls-3"
          x="21.69"
          y="21.34"
          width="8.88"
          height="3.43"
          rx="1.05"
        />
        <path
          class="cls-4"
          d="M24,0a1,1,0,0,1,.67.28l0,0,7,7.79a1,1,0,0,1,.24.53v.07l0,6.19A1,1,0,0,1,30,15V9.62H24.31a1,1,0,0,1-.95-.89V1.9H7.46A1.13,1.13,0,0,0,6.35,3V26.59A1.12,1.12,0,0,0,7.4,27.71H18a1,1,0,0,1,1,.95,1,1,0,0,1-.9.95H7.46a3,3,0,0,1-3-2.95V3A3,3,0,0,1,7.38,0H24Zm1.3,3.84V7.72h3.47L25.26,3.84Z"
        />
        <path
          class="cls-4"
          d="M9.74,19.29h7.07a.95.95,0,0,1,0,1.9H9.74a.95.95,0,0,1,0-1.9Zm0,3.8h7.07a1,1,0,0,1,0,1.91H9.74a1,1,0,0,1,0-1.91ZM15,3.94h.08a1.64,1.64,0,0,1,.54.13l.07,0,6.15,3.28a1.46,1.46,0,0,1,.28,2.38v4.07a.74.74,0,0,1-1.47,0V10.59l-1,.52v3.26a.73.73,0,0,1-.35.63l0,0L15.39,17.1a.72.72,0,0,1-.64,0l-.05,0L10.76,15a.72.72,0,0,1-.39-.6v-3.3L8.2,10a1.46,1.46,0,0,1-.06-2.54l.06,0,6.15-3.28A1.43,1.43,0,0,1,15,3.94ZM21.42,15a.74.74,0,0,1,.75.72.75.75,0,0,1-.73.75h0a.74.74,0,0,1,0-1.48Zm-3.17-3.12-2.53,1.35a1.45,1.45,0,0,1-1.3,0l-.07,0L11.84,11.9v2L15,15.62l3.21-1.69ZM15,5.41,8.92,8.68,15,11.94l6.12-3.26L15,5.41Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 38.19">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="29.59" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="29.59" rx="13.61" ry="6.79" />
        <line class="cls-3" x1="25.42" y1="18.78" x2="25.42" y2="28.38" />
        <rect
          class="cls-3"
          x="20.98"
          y="21.34"
          width="8.88"
          height="3.43"
          rx="1.05"
        />
        <path
          class="cls-4"
          d="M23.25,0a1,1,0,0,1,.67.28l0,0,7,7.79a1,1,0,0,1,.24.53v.07l0,6.19a1,1,0,0,1-.91,1,1,1,0,0,1-1-.86V9.62H23.6a1,1,0,0,1-1-.89V1.9H6.75A1.13,1.13,0,0,0,5.64,3V26.59a1.12,1.12,0,0,0,1.05,1.12H17.31a1,1,0,0,1,1,.95.93.93,0,0,1-.9.95H6.75a3,3,0,0,1-3-2.95V3A3,3,0,0,1,6.67,0H23.25Zm1.3,3.84V7.72H28L24.55,3.84Z"
        />
        <path
          class="cls-4"
          d="M9,19.29H16.1a1,1,0,0,1,0,1.9H9a.95.95,0,0,1,0-1.9Zm0,3.8H16.1a1,1,0,0,1,0,1.91H9a1,1,0,0,1,0-1.91ZM14.32,3.94h.08a1.64,1.64,0,0,1,.54.13l.07,0,6.15,3.28a1.46,1.46,0,0,1,.28,2.38v4.07a.74.74,0,0,1-1.47,0V10.59l-1,.52v3.26a.73.73,0,0,1-.35.63l0,0L14.68,17.1a.72.72,0,0,1-.64,0l0,0L10.05,15a.72.72,0,0,1-.39-.6v-3.3L7.49,10a1.46,1.46,0,0,1-.06-2.54l.06,0,6.15-3.28a1.43,1.43,0,0,1,.61-.17ZM20.7,15a.74.74,0,0,1,.76.72.75.75,0,0,1-.73.75h0a.74.74,0,0,1,0-1.48Zm-3.16-3.12L15,13.24a1.45,1.45,0,0,1-1.3,0l-.07,0L11.13,11.9v2l3.2,1.69,3.21-1.69ZM14.32,5.41,8.21,8.68l6.11,3.26,6.12-3.26L14.32,5.41Z"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.88px;
    }
    .cls-4 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.5px;
    }
    .cls-4 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3 {
      fill: none;
      stroke: #1ca586;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.29px;
    }
    .cls-4 {
      fill: #25a98c;
    }
  }
</style>
